import React, { useEffect } from "react";
import {
  Badge,
  Box,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import PulsingBadge from "../../base/PulsingBadge";
import theme from "../../../theme";
import { useDispatch, useSelector } from "../../../store";
import { markAlertAsRead } from "../../../slices/alert";
import SiteAlert from "../../../types/siteAlert";

interface Props {
  alert: SiteAlert;
}

const AlertComponent: React.FC<Props> = (props) => {
  const { alert } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { menuOpen } = useSelector((store) => store.shared);

  const handleAlertClick = () => {
    navigate(`/tile/${alert.tileId}`);
  };

  useEffect(() => {
    if (menuOpen === "alerts") {
      const timeout = setTimeout(() => {
        if (!alert.read) {
          dispatch(markAlertAsRead(alert.stringId ?? alert.id.toString()));
        }
      }, 2000);

      return () => clearTimeout(timeout);
    }
  }, [dispatch, menuOpen, alert]);

  return (
    <Box key={alert.id} display="flex">
      <ListItem disablePadding>
        <ListItemButton onClick={() => handleAlertClick()}>
          <ListItemIcon sx={{ paddingLeft: 2 }}>
            {!alert.read ? (
              <PulsingBadge color={theme.palette.error.main} />
            ) : (
              <Badge
                variant="dot"
                sx={{
                  "& .MuiBadge-badge": {
                    height: "12px",
                    width: "12px",
                    borderRadius: "6px",
                    backgroundColor: theme.palette.background.default,
                  },
                }}
              />
            )}
          </ListItemIcon>
          <ListItemText
            primary={alert.value}
            primaryTypographyProps={{
              fontSize: 16,
              color: "primary",
              paddingY: 1,
              paddingRight: 2,
              whiteSpace: "pre-line",
            }}
          />
        </ListItemButton>
      </ListItem>
    </Box>
  );
};

export default AlertComponent;
